/**
 * Must be the first import in src/index.js (before wdyr/React) so suppression
 * runs before CRA dev overlay modules initialize.
 */
import { suppressResizeObserverLoopError } from './suppressResizeObserverLoopError';

suppressResizeObserverLoopError();
